import { GenericResult } from '@/models/common/results/generic-result';
import { BusinessProspect, BusinessProspectPaymentStatus } from '@/models/prospects/business-prospect';
import { BusinessProspectConfiguration } from '@/models/prospects/business-prospect-configuration';
import i18n from '@/plugins/i18n';
import { appService, axiosService } from '.';

export default class ProspectsService {
    public async getBusinessProspect(id: number): Promise<BusinessProspect> {
        return new BusinessProspect(
            (await axiosService.anonymousInstance.get(`prospects/organization/businesses/${id}`)).data,
        );
    }

    public async getBusinessProspectConfiguration(): Promise<BusinessProspectConfiguration> {
        return new BusinessProspectConfiguration(
            (await axiosService.anonymousInstance.get('prospects/organization/businesses/new/configuration')).data,
        );
    }

    public async newBusinessProspect(businessProspect: BusinessProspect): Promise<GenericResult> {
        return new GenericResult(
            (await axiosService.anonymousInstance.post('prospects/organization/businesses/new', businessProspect)).data,
        );
    }

    public async updateBusinessProspectPaymentStatusToPaymentError(id: number) {
        return (await axiosService.anonymousInstance.post(`prospects/organization/businesses/${id}/update-payment-status/${BusinessProspectPaymentStatus.PaymentError}`)).data;
    }

    public async updateBusinessProspectPaymentStatusToPaidCorrectly(businessProspect: BusinessProspect, sendNotificationEmail: boolean = false): Promise<boolean> {
        if (sendNotificationEmail) {
            const application = appService.getCurrentApplication();
            const returnUrlPart = `/dashboard?businessProspectId=${businessProspect.id}&ui_locales=${i18n.locale}`;
            const acceptanceUrlFormat = `${process.env.VUE_APP_IDENTITY_SERVER_URL}/Account/Register` +
                `?userEmail=${businessProspect.userEmail}` +
                `&userLanguageId={0}` +
                `&userLanguageCulture=${i18n.locale}` +
                `&returnUrl=${escape(application.clientUri + returnUrlPart)}` +
                `&ui_locales=${i18n.locale}`;

            return (await axiosService.anonymousInstance.post(
                `prospects/organization/businesses/${businessProspect.id}/update-payment-status/${BusinessProspectPaymentStatus.PaidCorrectly}` +
                `?sendNotificationEmail=true` +
                `&notificationLanguageCulture=${i18n.locale}` +
                `&notificationAcceptanceUrlFormat=${escape(acceptanceUrlFormat)}`,
            )).data;
        }

        return (await axiosService.anonymousInstance.post(`prospects/organization/businesses/${businessProspect.id}/update-payment-status/${BusinessProspectPaymentStatus.PaidCorrectly}`)).data;
    }
}

export const prospectsService = new ProspectsService();
